import {
	RESET_STATE,
	SET_CATEGORIES,
	SET_IS_CATEGORIES_LOADING,
	SET_IS_TENDER_COMPANIES_LOADING,
	SET_IS_TENDER_TYPES_LOADING,
	SET_IS_TYPES_LOADING,
	SET_TENDER_COMPANIES,
	SET_TENDER_TYPES,
	SET_TYPES,
} from './actions';

export const initialState = {
	categories: null,
	isCategoriesLoading: false,
	tenderTypes: null,
	isTenderTypesLoading: false,
	tenderCompanies: null,
	isTenderCompaniesLoading: false,
	types: null,
	isTypesLoading: false,
};

const orderGroupsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case SET_CATEGORIES:
			return {
				...state,
				categories: payload,
			};
		case SET_IS_CATEGORIES_LOADING:
			return {
				...state,
				isCategoriesLoading: payload,
			};
		case SET_TENDER_TYPES:
			return {
				...state,
				tenderTypes: payload,
			};
		case SET_IS_TENDER_TYPES_LOADING:
			return {
				...state,
				isTenderTypesLoading: payload,
			};
		case SET_TENDER_COMPANIES:
			return {
				...state,
				tenderCompanies: payload,
			};
		case SET_IS_TENDER_COMPANIES_LOADING:
			return {
				...state,
				isTenderCompaniesLoading: payload,
			};
		case SET_TYPES:
			return {
				...state,
				types: payload,
			};
		case SET_IS_TYPES_LOADING:
			return {
				...state,
				isTypesLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default orderGroupsContainerReducer;
